
/*****************************************
 /store 仓库
 store里面有4个核心内容，State、Getters、Mutations和Actions
 存储数据和管理数据方法的仓库，一个应用或项目只能存在一个Store实例
 响应式全局变量，不能直接改变 store 中的状态。改变 store 中的状态的唯一途径就是显式地提交(commit) mutations。
 *****************************************/

import Vue from 'vue'
import Vuex from 'vuex'
import { Notification } from 'element-ui';
import {getRequest} from "../utils/api";
//import '../utils/stomp'
//import '../utils/sockjs'

Vue.use(Vuex)

const now = new Date();

const store = new Vuex.Store({
    // 主要定义了需要的属性，只有在这里定义的属性，在使用时才能获取的到
    state: {
        routes: [],
        menus: [],
        menuTabs: [],
        activeTab: '/home',
        sessions: {},
        hrs: [],
        currentSession: null,
        currentHr: JSON.parse(window.sessionStorage.getItem("user")),
        filterKey: '',
        stomp: null,
        isDot: {}
    },
    // 这里是对后台传来的数据进行操作，把我们需要的数据赋值给在state里面定义那个数组里
    // 这是Veux设计很重要的一点，就是把处理数据逻辑方法全部放在mutations里面，使得数据和视图分离。
    mutations: {
        INIT_CURRENTHR(state, hr) {
            state.currentHr = hr;
            console.log("HR_USER_INFO", JSON.stringify(state.currentHr))
            console.log("HR_USER_INFO", state.currentHr)
        },
        INIT_MenuTabs(state, data) {
            state.menuTabs = data;
        },
        INIT_ActiveTab(state, data) {
            state.activeTab = data;
        },
        initRoutes(state, data) {
            state.routes = data;
            state.menus = []
            state.routes.forEach(item => {
                item.children.forEach(child => {
                    state.menus.push(
                        {
                            name: child.name,
                            path: child.path,
                            icon: child.iconCls
                        }
                    )
                })
            })
            // console.log("menus", this.menus)
        },
        changeCurrentSession(state, currentSession) {
            Vue.set(state.isDot, state.currentHr.username + '#' + currentSession.username, false);
            state.currentSession = currentSession;
        },
        addMessage(state, msg) {
            let mss = state.sessions[state.currentHr.username + '#' + msg.to];
            if (!mss) {
                // state.sessions[state.currentHr.username+'#'+msg.to] = [];
                Vue.set(state.sessions, state.currentHr.username + '#' + msg.to, []);
            }
            state.sessions[state.currentHr.username + '#' + msg.to].push({
                content: msg.content,
                date: new Date(),
                self: !msg.notSelf
            })
        },
        INIT_DATA(state) {
            //浏览器本地的历史聊天记录可以在这里完成
            let data = localStorage.getItem('vue-chat-session');
            if (data) {
                state.sessions = JSON.parse(data);
            }
        },
        INIT_HR(state, data) {
            state.hrs = data;
        }
    },
    // 主要是与后台进行交互，并获取数据，然后传给mutations里面进行操作
    actions: {
        /*
        connect(context) {
            let prefix = "/pbs-ws-dev"
            let WEBSOCKET_URL = prefix + "/ws/ep"
            //context.state.stomp = Stomp.over(new SockJS('/ws/ep'));
            let socket = new SockJS(WEBSOCKET_URL);
            context.state.stomp = Stomp.over(socket);

            context.state.stomp.connect({}, success => {
                console.log("stompClient connect success...");

                context.state.stomp.subscribe('/user/queue/chat', msg => {
                    let receiveMsg = JSON.parse(msg.body);
                    if (!context.state.currentSession || receiveMsg.from != context.state.currentSession.username) {
                        Notification.info({
                            title: '【' + receiveMsg.fromNickname + '】发来一条消息',
                            message: receiveMsg.content.length > 10 ? receiveMsg.content.substr(0, 10) : receiveMsg.content,
                            position: 'bottom-right'
                        })
                        Vue.set(context.state.isDot, context.state.currentHr.username + '#' + receiveMsg.from, true);
                    }
                    receiveMsg.notSelf = true;
                    receiveMsg.to = receiveMsg.from;
                    context.commit('addMessage', receiveMsg);
                })
            }, error => {
                console.log("stompClient connect error...");
            })
        },
        initData(context) {
            context.commit('INIT_DATA')
            getRequest("/chat/hrs").then(resp => {
                if (resp) {
                    context.commit('INIT_HR', resp);
                }
            })
        }
        */
    }
})

store.watch(function (state) {
    return state.sessions
}, function (val) {
    localStorage.setItem('vue-chat-session', JSON.stringify(val));
}, {
    deep: true/*这个貌似是开启watch监测的判断,官方说明也比较模糊*/
})


export default store;
